import {
  ENTRY_DATA_FUNDED_COMPANY_GROUP_TABLE_KEY as FUNDED_COMPANY,
  ENTRY_DATA_FUNDED_COMPANY_TABLE_KEYS as FUNDED_COMPANY_TABLE_KEYS,
  ENTRY_DATA_FUNDED_COMPANY_GROUP_SHELL_KEYS as FUNDED_COMPANY_GROUP_SHELL_KEYS,
  ENTRY_DATA_FUNDED_COMPANY_SHELL_KEYS as FUNDED_COMPANY_SHELL_KEYS,
} from "@frontend/common";

import { FundingFilingGroupTable } from "@/types/ventureCapital.types";
import { TableCreatorTableList } from "@FillInTableContainer/shared/types/tableCreator.types";

interface VentureCapitalFundedCompanyLayout {
  groupTableKey: FundingFilingGroupTable;
  tableList: TableCreatorTableList;
}

export const VENTURE_CAPITAL_FUNDED_COMPANY_GROUP_TABLE_LAYOUT: VentureCapitalFundedCompanyLayout =
  {
    groupTableKey: FUNDED_COMPANY,
    tableList: [
      {
        tableKey: FUNDED_COMPANY_TABLE_KEYS.none,
        groupShellList: [
          {
            groupShellKey: FUNDED_COMPANY_GROUP_SHELL_KEYS.companyInformation,
            shellList: [
              {
                shellKey: FUNDED_COMPANY_SHELL_KEYS.companyName,
              },
              {
                shellKey: FUNDED_COMPANY_SHELL_KEYS.companyDescription,
              },
            ],
          },
        ],
      },
    ],
  };
